import { takeLatest, put, call } from 'redux-saga/effects';

import { listImplantacaoAnimal } from '../service';
import {
  TABLE_IMPLANTACAO_ANIMAL,
  TABLE_IMPLANTACAO_ANIMAL_PENDING,
  TABLE_IMPLANTACAO_ANIMAL_SUCCESS,
  TABLE_IMPLANTACAO_ANIMAL_FAILURE
} from '../actionTypes';

function* sagaListImplantacaoAnimal(action) {
  yield put({ type: TABLE_IMPLANTACAO_ANIMAL_PENDING })

  try {
    const table = yield call(listImplantacaoAnimal, action.args)
    yield put({ type: TABLE_IMPLANTACAO_ANIMAL_SUCCESS, table: table })
  } catch (error) {
    yield put({ type: TABLE_IMPLANTACAO_ANIMAL_FAILURE })
  }
}

export default function* watchListImplantacaoAnimal() {
  yield takeLatest(TABLE_IMPLANTACAO_ANIMAL, sagaListImplantacaoAnimal)
}